import type { CISProviderBehavior } from '../types';

export const paymentusCISBehavior: CISProviderBehavior = {
	label: 'Paymentus',
	getTestPanelConfig() {
		return { show: true, altText: 'Paymentus' };
	},
};
